import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const PostingLimitModal = ({
  open,
  onClose,
  maxedOutContent,
  allowedContent,
}) => {
  const isPartialLimit = allowedContent?.length > 0;
  const navigate = useNavigate();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="posting-limit-title"
      sx={{
        "& .MuiDialog-paper": {
          backgroundColor: "#fff",
          borderRadius: "20px",
          padding: { xs: "15px", sm: "15px", md: 0 },
          maxWidth: { xs: "95%", sm: "450px", md: "575px" },
          width: "100%",
        },
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(0, 0, 0, 0.7)",
        },
      }}
    >
      <DialogContent>
        <Box textAlign="center">
          {/* Header */}
          <Typography
            id="posting-limit-title"
            variant="h6"
            fontWeight={600}
            sx={{
              fontSize: { xs: "20px", sm: "24px", md: "28px" },
              color: "#2A4876",
              mb: 2,
            }}
          >
            Posting Limit Reached
          </Typography>

          {/* Body */}
          <Typography
            sx={{
              fontSize: { xs: "14px", sm: "15px", md: "16px" },
              lineHeight: 1.6,
              color: "#152134",
              textAlign: "center",
              mb: 3,
              px: { xs: 0, sm: 1 },
            }}
          >
            {isPartialLimit ? (
              <>
                You’ve reached the maximum number of{" "}
                <strong>{maxedOutContent?.join(", ")}</strong> allowed on your
                current plan. You can still post{" "}
                <strong>{allowedContent?.join(", ")}</strong> to keep engaging
                the Echo community.
                <br />
                <br />
                Upgrade your plan to unlock more posting opportunities, maximize
                visibility, and share more of your company’s expertise with the
                Echo community!
              </>
            ) : (
              <>
                You’ve reached the maximum number of posts allowed on your
                current plan.
                <br />
                <br />
                Upgrade your plan to unlock more posting opportunities, maximize
                visibility, and share more of your company’s expertise with the
                Echo community!
              </>
            )}
          </Typography>

          {/* Buttons */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: 2,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              onClick={onClose}
              sx={{
                backgroundColor: "#f1f1f1",
                color: "#2A4876",
                textTransform: "none",
                borderRadius: "50px",
                width: { xs: "100%", sm: "40%" },
                height: { xs: "40px", sm: "48px" },
                fontSize: { xs: "14px", sm: "16px" },
                fontWeight: 600,
                "&:hover": {
                  backgroundColor: "#e0e0e0",
                },
              }}
            >
              Close
            </Button>

            <Button
              onClick={() => navigate("/profile/edit-subscription")}
              sx={{
                backgroundColor: "#2A4876",
                color: "#fff",
                textTransform: "none",
                borderRadius: "50px",
                width: { xs: "100%", sm: "50%" },
                height: { xs: "40px", sm: "48px" },
                fontSize: { xs: "14px", sm: "16px" },
                fontWeight: 600,
                "&:hover": {
                  backgroundColor: "#1e365c",
                },
              }}
            >
              Upgrade Plan
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PostingLimitModal;
